<div class="role-tab-inner">
    <div class="row fields-group">
        <div class="col-8">
            <div class="list-title d-flex w-100 pr-3">
                <span class="field-required"> {{ 'Name' | translate }} </span>
                <span class="ml-auto text-right toggle">
                    {{ 'Active' | translate }}
                    <i class="ml-2 fas toggle-label {{form.active ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                        (click)="toggleActive();"></i>
                </span>
                <det-popover (click)="showDeterminant = true;$event.stopPropagation();"
                    [extraClasses]="hasDeterminant(form) ? 'active' : ''" [determinant]="form.jsonDeterminants"
                    [hasErrors]="hasError(form.id)" [placement]="'left'"
                    [determinantMapById]="determinantMapById"></det-popover>
            </div>
            <form class="form-controller">
                <input type="text" (blur)="updateForm();" name="name" required="" [(ngModel)]="form.name"
                    class="form-control">
            </form>
        </div>
        <div class="col-4">
            <div class="list-title d-flex w-100 pr-3">
                <span class="field-required"> {{ 'Shortname' | translate }} </span>
            </div>
            <form novalidate="" class="form-controller">
                <input type="text" (blur)="updateForm();" name="shortName" [(ngModel)]="form.shortName" maxlength="20"
                    class="form-control">
            </form>
        </div>
    </div>
</div>

<drawer [title]="'Manage determinants'" [showHeader]="showDrawerHeader" [isClosed]="!showDeterminant"
    (saveEvent)="updateForm()" [embedded]=false [contextLabel]="form.name" (closeEvent)="showDeterminant = false;"
    class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager *ngIf="serviceId && form" [serviceId]="serviceId" [determinantMapById]="determinantMapById"
            [jsonString]="form.jsonDeterminants" [showBuilder]=true [embedded]="false"
            (builderUpdated)="temoupdateDeterminant($event)" (cancel)="showDeterminant = false;"
            (updateHeader)="showModalHeader($event)" class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>